import React from 'react';
import classNames from 'classnames';

import { API_TARGET, BUILD_COMMIT, BUILD_TIME, MODE } from '../../config';
import { format } from '../../utils/DateUtils';
import { useAuth } from '../../contexts/AuthContext';
import { cognitoConstants } from '../../consts';
import { systemApi } from '../../APIs/systemApi';
import { useGet } from '../../hooks/useApi';

export const EnvRibbon = () => {
    return <div className={classNames('dev-ribbon', MODE)}>{MODE}</div>;
};

export const DevInfo = () => {
    const { user: userInfo, isAuthenticated } = useAuth();
    const { data: systemInfo } = useGet(systemApi.get.info);
    return (
        <div className="dev-area">
            <ul className="vertical">
                <li>
                    <label>FE:</label>
                    <abbr
                        title={`${BUILD_COMMIT} - ${format(BUILD_TIME, 'yyyy/MM/dd HH:dd:ss')}`}
                    >
                        {BUILD_COMMIT.substring(0, 8)}
                    </abbr>
                </li>
                {systemInfo ? (
                    <li>
                        <label>BE:</label>
                        <abbr title={systemInfo.version}>
                            {systemInfo.version.substring(0, 8)}
                        </abbr>
                    </li>
                ) : null}
            </ul>
            {isAuthenticated ? (
                <ul className="vertical">
                    <li>
                        <label>tenant:</label>
                        {userInfo?.tenantId}
                    </li>
                    <li>
                        <label>user:</label>
                        {userInfo?.userId}
                    </li>
                </ul>
            ) : (
                <ul className="vertical">
                    <li>
                        <label>api:</label>
                        {API_TARGET}
                    </li>
                    <li>
                        <label>userPool:</label>
                        {cognitoConstants.Auth.Cognito.userPoolClientId}
                    </li>
                </ul>
            )}
        </div>
    );
};
